// Vuex
import { defaultObj } from './state'

// Utilities
import isEmpty from '../../utility/isEmpty'

// Validators
import { incomeIsValid } from '../../validators/income'

export default {
  deleteIncome (state, data) {
    state.incomeList.splice(data.incomeIndex, 1)
  },

  setIncomeInactive (state, data) {
    state.incomeList[data.incomeIndex].active = false
  },

  updateIncome (state, data) {
    const currentIncome = state.incomeList[data.incomeIndex]

    if (isEmpty(currentIncome)) {
      state.incomeList.push(data.income)
      return
    }

    const newIncome = {
      incomeId: data.income.incomeId || currentIncome.incomeId,
      incomeSource: data.income.incomeSource || currentIncome.incomeSource,
      incomeName: data.income.incomeName || currentIncome.incomeName,
      incomeAmount: data.income.incomeAmount || currentIncome.incomeAmount,
      isPrimary: data.income.isPrimary || currentIncome.isPrimary,
      lastPayDate: data.income.lastPayDate || currentIncome.lastPayDate,
      payFrequency: data.income.payFrequency || currentIncome.payFrequency,
      unitasEmployerId: data.income.unitasEmployerId || currentIncome.unitasEmployerId,
      active: true
    }

    state.incomeList[data.incomeIndex] = newIncome
  },

  updateIncomeIndex (state, data) {
    state.incomeIndex = data.incomeIndex
  },

  updateIncomeList (state, data) {
    state.incomeList = data.incomeList ? data.incomeList.filter((income) => incomeIsValid(income)) : []
  },

  updateExpenses (state, data) {
    if (data.rent !== undefined) {
      state.rent = data.rent
    }

    if (data.utilities !== undefined) {
      state.utilities = data.utilities
    }

    if (data.insurance !== undefined) {
      state.insurance = data.insurance
    }

    if (data.otherExpenses !== undefined) {
      state.otherExpenses = data.otherExpenses
    }

    if (data.signatureInitials !== undefined) {
      state.signatureInitials = data.signatureInitials
    }
  },

  reset (state) {
    state = Object.assign(state, defaultObj)
  }
}
